import React from 'react'
import classes from './resource/Buttons.module.css'

const DefaultBtn = ({ label }) => {
    return <button className={classes.defaultBtn}>{label}</button>
}

export default DefaultBtn
